export default "__VITE_ASSET__e43d47cb__"